export const LAYOUT = {
  HEADER_HEIGHT: 52,
  ITEM_HEIGHT: 44,
  MENU_WIDTH: 260,
  VIEWPORT_MARGIN: 16,
  BOTTOM_PADDING: 32
} as const;

export const DEFAULT_TRIGGER_POSITION = {
  x: typeof window !== "undefined" ? window.innerWidth / 2 : 0,
  y: typeof window !== "undefined" ? window.innerHeight - 100 : 0
};

/** Must exceed the popover exit animation (150 ms) plus a render frame buffer. */
export const CLEANUP_DELAY_MS = 300;

/** Must exceed the popover exit animation so the loading sheet fully exits before the actions sheet mounts. */
export const LOADING_TO_ACTIONS_DELAY_MS = 200;
